// AUTO-GENERATED by scripts/generate-contracts.mjs from the .md sidecar.
// Hand edits will be overwritten on the next run. To customise this
// component's contract (add actions, structured props, custom control
// kinds, glyph pickers), remove this file's auto-generated marker and
// hand-author it — the generator skips files without the marker.

import { z } from "zod";
import { contract } from "@gradeui/contracts";

export const CalendarContract = contract({
  name: "Calendar",
  description: "An inline date grid — date-of-birth pickers in profile forms, scheduling screens with a month view, range selection in reporting filters. For a compact trigger-and-popover input, use DatePicker / DateRangePicker (which wrap Calendar internally). For one-off relative dates (\"yesterday\", \"last week\") use a Select instead.",
  import: "@gradeui/ui",
  aliases: ["calendar","date grid","month view","scheduler grid","calendar view","multidate picker","react native calendars"],
  subcomponents: ["CalendarDayButton"],
  composesWith: ["Popover (DatePicker composes them)","Card (inline scheduling card)","Dialog (full-screen mobile date pick)"],
  styleDefaults: {"Calendar":"bg-background group/calendar p-3 [--cell-size:2rem] [[data-slot=card-content]_&]:bg-transparent [[data-slot=popover-content]_&]:bg-transparent"},
  props: {
  "mode": {
      schema: z.enum(["single", "multiple", "range"]).optional(),
      design: "knob",
      description: "picks one date, several dates, or a [from, to] range",
  },
  "selected": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "controlled selection; shape matches `mode`",
  },
  "onSelect": {
      schema: z.unknown().optional(),
      design: "event",
      description: "fires with the new selection",
  },
  "month": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "controlled displayed month",
  },
  "defaultMonth": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "uncontrolled initial month",
  },
  "onMonthChange": {
      schema: z.unknown().optional(),
      design: "event",
  },
  "numberOfMonths": {
      schema: z.number().optional(),
      design: "knob",
      description: "render multiple months side by side, useful for range pickers",
  },
  "disabled": {
      schema: z.unknown().optional(),
      design: "plumbing",
  },
  "captionLayout": {
      schema: z.enum(["label", "dropdown", "dropdown-months", "dropdown-years"]).optional(),
      design: "knob",
  },
  "className": {
      schema: z.string().optional(),
      design: "plumbing",
  },
  },
});
